import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import cloneDeep from 'lodash/cloneDeep';
import ReactRouterPropTypes from 'react-router-prop-types';
import queryString from 'query-string';

import moment from 'moment';
import { Input, Datepicker } from '../../common/components';
import Breadcrumb from '../../common/components/breadcrumb.component';
import { saveBreakdown } from '../services/breakdown.service';
import { withDebounce } from '../../common/services/utils';
import { getWarranty } from '../../warranty/services/warranty.service';
import BreakdownModel from '../models/breakdown.model';

const initialState = {
  vin: '',
  notes: '',
};

class Breakdown extends PureComponent {
  state = cloneDeep(initialState);

  async componentDidMount() {
    const { location } = this.props;
    const { warranty } = queryString.parse(location.search);

    const {
      data: {
        car: {
          id,
          vin,
          year,
          engine,
          mileage,
          power,
          model: {
            name: modelName,
          },
          manufacturer: {
            name: manufacturerName,
          },
        },
      },
    } = await getWarranty(warranty);


    this.setState({
      id,
      vin,
      year,
      engine,
      mileage,
      power,
      modelName,
      manufacturerName,
    });
  }

  onInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  onVinChange = (name, value) => {
    this.setState({
      [name]: value,
    }, withDebounce(() => this.handleGetData()));
  }

  onFormSave = async () => {
    try {
      const {
        id,
        mileage,
        email,
        incidentPlace,
        date,
        notes,
      } = this.state;
      const { location, history } = this.props;
      const { warranty } = queryString.parse(location.search);
      const payload = {
        carId: id,
        warranty,
        mileage,
        email,
        incidentPlace,
        notes,
        date: moment(date).toDate(),
      };

      const breakdownModel = new BreakdownModel(payload);
      const errors = breakdownModel.validate();

      if (!errors) {
        try {
          await saveBreakdown(payload);

          history.replace(`/warranty-details/${warranty}`);
        } catch (err) {
          console.log(errors);
        }
      }

      this.setState({ errors });
    } catch (error) {
      console.error(error);
    }
  }


  render() {
    const {
      vin,
      mileage,
      year,
      engine,
      power,
      modelName,
      manufacturerName,
      incidentPlace,
      date,
      notes,
      email,
      errors,
    } = this.state;

    return (
      <>
        <Breadcrumb title="Zgłoszenie nowej awarii" />
        <div className="content">
          <div className="card">
            <div className="card-header">
              Dane awarii
            </div>
            <div className="card-body card-block">
              <div className="form-horizontal">
                <Input
                  label="Numer VIN samochodu"
                  id="vin"
                  value={vin}
                  onChange={this.onVinChange}
                  horizontal
                  disabled
                />

                <Input
                  label="Model"
                  id="modelName"
                  value={modelName}
                  onChange={this.onInputChange}
                  horizontal
                  disabled
                />

                <Input
                  label="Marka"
                  id="manufacturerName"
                  value={manufacturerName}
                  onChange={this.onInputChange}
                  horizontal
                  disabled
                />

                <Input
                  id="engine"
                  label="Silnik"
                  value={engine}
                  onChange={this.onInputChange}
                  horizontal
                  disabled
                />

                <Input
                  id="power"
                  label="Moc"
                  value={power}
                  onChange={this.onInputChange}
                  horizontal
                  disabled
                />

                <Input
                  id="year"
                  label="Rok produkcji"
                  value={year}
                  onChange={this.onInputChange}
                  horizontal
                  disabled
                />

                <Input
                  id="mileage"
                  label="Przebieg"
                  value={mileage}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  id="email"
                  label="Email kontaktowy"
                  value={email}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  id="incidentPlace"
                  label="Miejscowość wystąpienia awarii"
                  value={incidentPlace}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Datepicker
                  selected={date || new Date()}
                  id="date"
                  label="Data wystąpienia awarii"
                  maxDate={new Date()}
                  onChange={this.onInputChange}
                />
                <Input
                  controlType="textarea"
                  label="Dodatkowe informacje"
                  id="notes"
                  value={notes}
                  errors={errors}
                  onChange={this.onInputChange}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end p-4">
              <button
                type="button"
                onClick={this.onFormSave}
                className="btn btn-primary btn-sm"
              >
                Zapisz
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

Breakdown.defaultProps = {

};

Breakdown.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(Breakdown);
